import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../_services/auth.service';

@Injectable({ providedIn: 'root' })
export class NoAuthGuard  {
  constructor(private router: Router, private authService: AuthService) {}

  canActivate() {
    const sessaoValida = this.authService.LocalStorage.usuarioValido();

    if (sessaoValida) {
      const estaExpirado = this.authService.LocalStorage.tokenEstaExpirado(sessaoValida);
      if (!estaExpirado) {
        this.router.navigate(['/index']);
        return false;
      }
    }

    return true;
  }
}
